import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import rightArrow from '../../assets/images/svg/right-arrow.svg';

const PreviewContainer = (props) => {
    return (
        <div className={`preview-tray ${props.cssClass}`}>
            <div className="preview-tray__header">
                {/* eslint-disable-next-line */}
                <a
                    id="close-preview-tray"
                    data-qa="close-preview-tray"
                    onClick={props.togglePreview}
                >
                    <img src={`${rightArrow}`} alt="Close Preview" />
                </a>
            </div>
            {props.message.length > 0 && (
                <div className="message">
                    {props.message}
                </div>
            )}
            {props.x && (
                <div className="preview-wrapper-x">
                    <div className="preview-clay-phone-x" />
                    <div
                        className={`preview-overlay-x ${props.versions.select.baseColorTheme === 2 ? 'dark-theme' : ''}`}
                    >
                        {props.children}
                    </div>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

export default connect(mapStateToProps)(PreviewContainer);
